import { CertificateRegistryApiTypes } from "@rshbintech.dboul/http";
import {
  prepareCryptoControlBlock,
  signCertificate,
} from "@rshbintech.dboul/utils";
import { getCustomErrorText } from "./get-custom-error-text";

export const checkSignPossibility = async (
  validCertificate: CertificateRegistryApiTypes.ShortCertInfo | undefined
) => {
  await new Promise((resolve, reject) => {
    if (!validCertificate) {
      reject(new Error("Проблема с получением сертификата"));
    } else {
      const setSigningMessage = () => {
        resolve(true);
      };

      const setSigningNotAvailable = (error: string) => {
        const errorText: string = getCustomErrorText(error);

        reject(errorText);
      };

      // подписываем произвольную строку, чтобы убедиться что серт, ключи, и криптопро впорядке
      const testDataToSign = prepareCryptoControlBlock("some text");

      signCertificate(
        validCertificate?.serial,
        testDataToSign,
        setSigningMessage,
        setSigningNotAvailable,
        true
      );
    }
  });
};
